module.exports = __webpack_public_path__ + "static/bg-checkout-ca55bae5313862754ec617ceb56be199.jpg";